import { lazy, Suspense } from 'react';

const DiagramRendererLazy = lazy(() =>
  import('../../teknav-diagrams.jsx').then(m => ({ default: m.DiagramRenderer }))
);

export function LazyDiagram(props) {
  return (
    <Suspense fallback={<div className="tek-diagram-skeleton" aria-hidden="true" />}>
      <DiagramRendererLazy {...props} />
    </Suspense>
  );
}
